<!--
 * @Author: MX
 * @Date: 2020-08-03 11:36:59
 * @LastEditTime: 2023-02-13 15:46:48
 * @Description: 服务管理 - 快件跟踪
-->
<template>
  <div class="expressTracking main-wrap">
    <div class="track-left">
      <base-input-tag ref="inputTag" v-model="searchKey" :validate="inputTagValid" :addTagOnBlur="true"
                      maxHeight="360px" class="cms-input-tag"></base-input-tag>
      <div class="track-left-btns">
        <el-button type="primary" class="b_reset h32" plain @click="resetSearch">{{ $lang('清空') }}</el-button>
        <el-button type="primary" class="h32" :loading="keyBtn" @click="searchFun">{{ $lang('立即查询') }}</el-button>
      </div>
    </div>
    <div class="track-right">
      <el-collapse v-model="activeName" v-if="traceList.length > 0">
        <el-collapse-item v-for="(tag, $index) in traceList" :key="tag.id" :title="$lang('运单编号')+'：' + tag.keyword" :name="$index">
          <div class="track-right_item" v-if="tag.details&&tag.details.length > 0">
            <el-steps direction="vertical" class="track-right_item_steps">
              <el-step v-for="(item, index) in tag.details" :key="index" :class="[index === 0 ? 'isFirst':'']">
                <template slot="icon">
                  <span class="track-right_item_status"> {{ item.status }}</span>
                </template>
                <template slot="title">
                  <span>{{ item.scanTime }}</span>
                  <span class="receive-picture" @click="preViewImg(item)" v-show="preViewImgFlag(item)">{{ $lang('收件图片') }}</span>
                </template>
                <template slot="description">
                  <span>{{ item.customerTracking }}</span>
                  <span class="sign-picture-btn" @click="signViewImg(item)" v-show="signViewImgFlag(item)">{{ $lang('查看图片') }}</span>
                </template>
              </el-step>
            </el-steps>
          </div>
          <div v-else class="no-data">{{ $lang('暂无数据') }}</div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <ImageView v-if="preViewVisible" :initialIndex='preViewIndex' :urlList='urlList' :onClose='preViewClose'></ImageView>
    <el-dialog class="sign-dialog" :title="$lang('预览图片')" :visible.sync="signViewShow" width="800px" :before-close="signViewClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="sign-view-content">
        <el-carousel ref="carouselPic" height="450px" indicator-position="none" :autoplay="false" arrow="never" @change="signViewChange">
          <el-carousel-item v-for="(item, index) in signList" :key="'el-carousel-item-' + index">
            <img :src="item" alt="" class="sign-img-priew"/>
          </el-carousel-item>
        </el-carousel>
        <img class="sign_left_icon" src="@/assets/images/icon_sign_left.png" alt="" @click="signLeftView"/>
        <img class="sign_right_icon" src="@/assets/images/icon_sign_right.png" alt="" @click="signRightView"/>
      </div>
      <div class="sign-view-footer"><el-button type="primary" @click="downSignImg" :loading="downLoading">{{ $lang('点击下载') }}</el-button></div>
    </el-dialog>
  </div>
</template>
<script>
import { getDetailByWaybillNos } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'
import ImageView from '@/components/ImageView.vue'

export default {
  name: 'ExpressTracking',
  components: {
    ImageView
  },
  data() {
    return {
      isShowFirst: false,
      searchKey: [],
      searchKeyOld: [],
      traceList: [], // 物流跟踪list
      inputTagValid: 'orderName',
      orderIds: '',
      preViewVisible: false,
      keyBtn: false,
      activeName: 0,
      preViewIndex: 0, // 当前预览设置
      urlList: [],
      signList: [], // 签收图片list
      signIndex: 0,
      downLoading: false,
      signViewShow: false // 签收图片弹框
    }
  },
  mounted() {
    this.orderIds = this.$route.params.orderIds
    if (this.orderIds) {
      this.searchKey = this.orderIds.split(',')
      this.searchKeyOld = this.orderIds.split(',')
      this.searchFun()
    }
    const waybillId = this.$route.query.waybillId
    if (waybillId) {
      this.searchKey = waybillId.split(',')
      this.searchFun()
    }
  },
  activated() {
    const waybillId = this.$route.query.waybillId
    if (waybillId) {
      this.searchKey = waybillId.split(',')
      this.searchFun()
    }
  },
  watch: {},
  methods: {
    signViewChange(val) {
      this.signIndex = val
    },
    signLeftView() {
      this.$refs.carouselPic.prev()
    },
    signRightView() {
      this.$refs.carouselPic.next()
    },
    // 签收图片下载
    downSignImg() {
      this.downLoading = true
      const link = document.createElement('a')
      link.href = this.signList[this.signIndex]
      link.setAttribute('download', 'xxxx')
      document.body.appendChild(link)
      link.click()
      link.remove()
      this.downLoading = false
    },
    // 签收弹框关闭
    signViewClose() {
      this.signViewShow = false
      this.downLoading = false
      this.signList = []
      this.signIndex = 0
    },
    // 重置搜索
    resetSearch() {
      this.searchKey = []
      this.searchKeyOld = []
      this.traceList = []
      this.$refs.inputTag.newTag = ''
      if (this.orderIds) this.$router.push({ path: `/redirect/expressTracking` })
    },
    clearData() {
      this.traceList = []
    },
    // 搜索
    searchFun() {
      const reqList = []
      if (!this.searchKey || this.searchKey.length === 0) return this.$message.warning(this.$lang('请输入单号'))
      if (this.searchKey.length > 10) return this.$message.warning(this.$lang('您查询的单号已超出10条'))
      //   const newArr = this.searchKey.filter(item => !this.searchKeyOld.some(ele => ele === item))// 单次只能查询10条数据
      //   if (newArr.length > 10) return this.$message.warning(this.$lang('单次只能查询10条数据'))
      //   this.searchKeyOld = this.searchKey.slice(0)
      this.searchKey.forEach(item => reqList.push(item))
      this.getOrderList(reqList)
    },
    // 查询单号
    async getOrderList(reqList) {
      // const params = { keywordList: reqList }
      this.keyBtn = true
      const { code, msg, data } = await getDetailByWaybillNos(reqList)
      this.keyBtn = false
      if (code !== RESPONSE_SUCCESS) return this.$message.warning(this.$lang(msg))
      this.traceList = data
    },
    // 手机号加*
    disposePhoneFun(num) {
      let start = ''
      let end = ''
      if (num) {
        start = num.toString().substring(0, 3)
        end = num.toString().substring(num.length - 4, num.length)
      }
      return start + '****' + end
    },
    // 查看图片
    preViewImg(item) {
      let pictures = []
      let collectPicUrlList = []
      if (item.pictures && item.pictures.length > 0) {
        pictures = item.pictures
      }
      if (item.collectPicUrlList && item.collectPicUrlList.length > 0) {
        collectPicUrlList = item.collectPicUrlList
      }
      this.urlList = [...pictures, ...collectPicUrlList]
      this.preViewVisible = true
    },
    /**
     * @description: 关闭预览
     */
    preViewClose() {
      this.preViewIndex = 0
      this.preViewVisible = false
    },
    // 已揽件、有图片显示预览图片按钮
    preViewImgFlag(item) {
      return (item.status === 'Picked-up' || item.status === '已揽件') && ((item.pictures && item.pictures.length > 0) || (item.collectPicUrlList && item.collectPicUrlList.length > 0))
    },
    // 已签收、有图片显示查看图片按钮
    signViewImgFlag(item) {
      return (item.status === '已签收' || item.status === 'Signed') && (item.signList && item.signList.length)
    },
    signViewImg(item) {
      this.signList = item.signList
      this.signViewShow = true
    }
  },
}
</script>

<style lang="scss" scoped>
.expressTracking {
  width: 100%;
  display: flex;
  flex-direction: row;

  .track-left {
    width: 390px;
    padding: 24px;
    box-sizing: border-box;

    .track-left-btns {
      float: right;
      margin-top: 16px;
    }
  }

  .b_reset {
    width: 88px;
  }

  .track-right {
    flex: 1;
    border: 16px solid #EDEEF3;
    padding: 16px 24px;
    background: #fff;
    overflow: auto;

    .no-data {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .track-right_item {
      margin-left: 60px;
    }

    .track-right_item_status {
      position: absolute;
      top: -9px;
      right: 0px;
      line-height: 24px;
      width: 70px;
    }
  }

  .receive-picture {
    display: inline-block;
    margin-left: 10px;
    font-size: 16px;
    color: red;
    cursor: pointer;
  }

  .sign-picture-btn {
    text-decoration: underline;
    color: #e60012;
    margin-left: 8px;
    font-size: 12px;
    user-select: none;

    &:hover {
      cursor: pointer;
    }

    &:active {
      opacity: 0.8;
    }
  }
}
</style>
<style lang="scss">
.expressTracking {
  .input-tag-container {
    float: left;
    width: 100% !important;
    height: 160px;

    .vue-input-tag-wrapper {
      height: 160px !important;
      box-sizing: border-box;
    }
  }
  .el-collapse {
    border-bottom: 0;
    border-top-color: transparent !important;

    .el-collapse-item {
      background: #F7F7F9;
      border: 1px solid #EEEEEE;
      border-radius: 8px;
      margin-bottom: 24px;
      padding: 5px 24px;

      .el-collapse-item__header {
        background: #F7F7F9;
        font-weight: 600;
        justify-content: flex-start;
        font-size: 16px;
        padding-bottom: 0;
        border: 0;

        &.is-active {
          color: $--color-primary;
        }
      }

      .el-collapse-item__wrap {
        background: #F7F7F9;
        border: 0;
      }

      .el-collapse-item__arrow {
        margin-left: 16px;
      }
    }
  }
  .el-step {
    position: relative;

    .el-step__head {
      display: flex;
      justify-content: center;
    }

    .el-step__icon {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      border: 0;
      background: #DDDDDD;
      position: relative;
      margin-top: 9px;
    }

    .el-step__description {
      margin-bottom: 12px;
    }

    .el-step__line {
      top: 20px;
    }

    &.isFirst {
      .track-right_item_status, .el-step__title, .el-step__description {
        color: #333333;
      }

      .el-step__icon {
        width: 8px;
        height: 8px;
        background: #51c419;
      }

      .track-right_item_status {
        font-weight: bold;
      }
    }
  }
  .sign-dialog {
    .el-dialog__body {
      padding-top: 0 !important;
      padding-bottom: 20px !important;
    }
  }
  .sign-view-content {
    background-color: #f2f2f2;
    height: 450px;
    position: relative;
    .sign-img-priew {
      width: 100%;
      height: 100%;
    }
    .sign_left_icon, .sign_right_icon {
      position: absolute;
      width: 56px;
      height: 56px;
      top: 197px;
      z-index: 100;
      &:hover {
        cursor: pointer;
        transform: scale(1.05);
      }
    }
    .sign_left_icon {
      left: 16px;
    }
    .sign_right_icon {
      right: 16px;
    }
  }
  .sign-view-footer {
    margin-top: 20px;
    text-align: center;
  }
}
</style>

